import React from "react";

import ViewAppBar from "../views/ViewAppBar";

import styled from "styled-components";

import ViewFooter from "../views/ViewFooter";

import ViewGerenciarInteressesAlugueis from "../views/ViewGerenciarInteressesAlugueis";
import { usePermissao } from "../uteis/permissaoAdm/usePermissao";

const ContainerComponente = styled.div`
  display: grid;
  grid-template: 100px 75vh 90rem 170rem 20rem / 100vw;
  @media (min-width: 1100px) {
    grid-template: 100px 100vh 20rem / 100vw;
  }
`;

const GerenciarInteressesAlugueis: React.FC = () => {
   const { isLoading, isValid } = usePermissao("OPE");
    
      if (isLoading) return <p>Verificando permissão...</p>;
      if (!isValid) return null;
    return (
  <ContainerComponente>
    <ViewAppBar />
    <ViewGerenciarInteressesAlugueis />
    <ViewFooter />
  </ContainerComponente>
)};
export default GerenciarInteressesAlugueis;
